import { is, prop } from 'ramda'

export const updateQueryCache = (newRecord, key) => oldData => {
  const oldRecords = prop(key, oldData)
  if (!oldRecords) return oldData
  if (is(Array, oldRecords)) {
    return { ...oldData, [key]: oldRecords.map(item => (item.id === newRecord?.id ? newRecord : item)) }
  }
  if (is(Object, oldRecords) && oldRecords.id === newRecord?.id) return newRecord
  return oldData
}

export const removeQueryCache = (newRecord, key) => oldData => {
  const oldRecords = prop(key, oldData)
  if (!oldRecords) return oldData
  if (is(Array, oldRecords)) {
    return { ...oldData, [key]: oldRecords.filter(item => item.id !== newRecord?.id) }
  }
  return oldData
}

export const refetchQuery = (queryState, key) => {
  const oldRecords = prop(key, queryState.data)
  const limit = queryState.variables.limit || 15
  const isPaginated = queryState.page > 1
  const isInfiniteScroll = oldRecords?.length > limit

  const query = queryState.observable?.queryInfo?.document
  let variables = { ...queryState.variables }
  if (isPaginated && isInfiniteScroll) {
    variables = { ...variables, page: 1, limit: queryState.page * limit }
  }

  queryState.client.query({ query, variables }).then(result => {
    if (result?.data) {
      queryState.updateQuery(() => result?.data)
    }
  })
}
